import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=14b2608d&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=14b2608d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b2608d",
  null
  
)

export default component.exports